import { Pipe, PipeTransform } from '@angular/core';
/**
 * AppAvatarInitialsPipe is used internally to extract the initials from a name.
 */
@Pipe({
  name: 'appAvatarInitials',
  standalone: true,
})
export class AppAvatarInitialsPipe implements PipeTransform {
  transform(value = ''): string {
    const [firstName, lastName] = value.split(' ');
    if (firstName && lastName) {
      return `${firstName[0]}${lastName[0]}`;
    }
    return value.substring(0, 2);
  }
}
